export const formatPrice = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const buildWaLink = (number, message) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

export const buildOrderMessage = (customer, items, total) => {
  const lines = [
    "Hello GlowinGifts,",
    "",
    "I would like to place an order.",
    "",
    "*Customer Details*",
    `Name: ${customer.name}`,
    `Phone: ${customer.phone}`,
  ];
  if (customer.alt_phone) lines.push(`Alternate Phone: ${customer.alt_phone}`);
  if (customer.email) lines.push(`Email: ${customer.email}`);
  lines.push(
    `Address: ${customer.address}, ${customer.city}, ${customer.state}`,
    `PIN: ${customer.pincode}`,
    "",
    "*Products*"
  );
  items.forEach((item, i) => {
    lines.push(`${i + 1}. ${item.name}${item.variant ? ` — ${item.variant.size}` : ""}`);
    lines.push(`   Qty: ${item.qty} × ${formatPrice(item.price)} = ${formatPrice(item.qty * item.price)}`);
  });
  lines.push("", `*Total: ${formatPrice(total)}*`);
  if (customer.notes) lines.push("", `Notes: ${customer.notes}`);
  lines.push("", "Please confirm availability.");
  return lines.join("\n");
};

export const buildQuickMessage = (product, variant, finalPrice) =>
  `Hello GlowinGifts,\n\nI'm interested in *${product.name}*${variant ? ` (${variant.size})` : ""}.\nPrice: ${formatPrice(finalPrice ?? (variant ? variant.price : product.price))}\n\nPlease share more details.`;

export const buildBulkMessage = () =>
  "Hello GlowinGifts,\n\nI'm interested in placing a bulk order. Please share details on volume pricing and lead times.";
